export class LoginUser {
  login: String;
  password: String;
}
